export const trackConversion = (conversionType, source = 'user_click') => {
  // Vercel Analytics event
  if (window.va) {
    window.va('event', {
      name: 'conversion_selected',
      data: {
        conversion_type: conversionType,
        source: source
      }
    });
  }

  // Google Analytics (if you're using it)
  if (window.gtag) {
    window.gtag('event', 'select_conversion', {
      'event_category': 'Conversion',
      'event_label': conversionType,
      'source': source
    });
  }
}; 